import { Injectable } from '@angular/core';

import { Profile, ProfileFacade, ProfileService, SessionFacade } from '@contact/upgrade';

/**
 * @deprecated prefer use AuthService|ProfileService
 */
@Injectable({
  providedIn: 'root',
})
export class SessionDeprecatedService {
  private _sessionId: string | undefined;
  private profile: Profile;

  get isSupFeatureEnabled() {
    return this.hasPermission('CSR_MAIL_INCOMING::self:supervisor_features_enabled');
  }

  constructor(
    private readonly profileFacade: ProfileFacade,
    private readonly sessionFacade: SessionFacade,
    private readonly profileService: ProfileService
  ) {
    this.profileFacade.profile$.subscribe(profile => (this.profile = profile));
    this.sessionFacade.token$.subscribe(token => (this._sessionId = token));
  }

  /**
   * @deprecated prefer use AuthService
   * Get current user session identifier.
   * @returns {string} the session identifier if exist, undefined else.
   */
  get(): string | undefined {
    return this._sessionId;
  }

  /**
   * @deprecated prefer use AuthService
   * Tests if the session exists or not.
   * @returns {boolean} true if the session identifier exists, false else
   */
  exists(): boolean {
    return !!this._sessionId && this._sessionId.length > 0;
  }

  /**
   * @deprecated prefer use ProfileService
   */
  getProfile(): Profile {
    return this.profile;
  }

  /**
   * @deprecated prefer use ProfileService
   * Tests if the subject has given permission.
   * @param {string} permission Permission that the subject is expected to have formed as following :
   *  <role>::<entity>:<action1>,<action2>, ...
   *  <role>::<entity>:<action>|<entity>:<action>|...
   *  <role>::<entity>:<action>&<entity>:<action>&...
   * @returns {boolean} Returns true if the subject has expected permission, false else.
   */
  hasPermission(permission: string): boolean {
    return this.profileService.hasPermission(permission);
  }

  /**
   * @deprecated prefer use ProfileService
   * Check if the subject has given roles.
   * @param {string[]} expectedRoles expectedRoles Roles that the subject is expected to have.
   * @returns {boolean} Returns true if the subject has all expected roles, false else.
   */
  hasRoles(expectedRoles: string[]): boolean {
    return this.profileService.hasRoles(expectedRoles);
  }

  /**
   * @deprecated prefer use ProfileService
   * Check if the subject has given parameters.
   * @param {string[]} expectedPerimeters Perimeters that the subject is expected to have.
   * @returns {boolean} Returns true if the subject has all expected perimeters, false else.
   */
  hasPerimeters(expectedPerimeters: string[]): boolean {
    return this.profileService.hasPerimeters(expectedPerimeters);
  }
}
